import { CategoryInterface, SubcategoryInterface } from "../types";
import { TechMapCategoryNewProxy } from "@me-team/host/main/graphql/types";

class CategoryTechMaps {
    public static categoryModuleCreator = (
        techMapsCategories: TechMapCategoryNewProxy[],
        categoryId: number | null,
        subcategoryId: number | null
    ): CategoryInterface[] => {
        const isActiveCategories = techMapsCategories?.filter((category) => !category?.deleted);

        return isActiveCategories.map((productCategory) => {
            return {
                id: productCategory.id,
                name: productCategory.name,
                isOpen: !!(productCategory.id === categoryId && subcategoryId),
                isPicked: !!(productCategory.id === categoryId && !subcategoryId),
                isSubcategoryPiked: !!(productCategory.id === categoryId && subcategoryId),
                subcategoryList: this.subcategoryModuleCreator(productCategory.childCategories, subcategoryId),
            };
        });
    };

    public static subcategoryModuleCreator = (
        subcategories: TechMapCategoryNewProxy[],
        currentSubcategoryId: number
    ): SubcategoryInterface[] => {
        const isActiveSubcategories = subcategories?.filter((subcategory) => !subcategory?.deleted);
        return isActiveSubcategories.map((subcategory) => {
            return {
                id: subcategory.id,
                name: subcategory.name,
                isPicked: subcategory.id === currentSubcategoryId,
            };
        });
    };
}

export default CategoryTechMaps;
